import { getLabel } from './labelStore';

/**
 * Asset-sale settlement status, computed by the backend from the sale's dues
 * and payments (helpers/assetSaleSettlement.helper.js) — not from `sumDebts`,
 * which is only the financed capital and never moves with payments.
 */
const STATUS_LABEL_KEYS = {
	settled: 'field.settled',
	pending: 'field.withBalance',
	noDebts: 'field.noFinancing',
};

export const SALE_STATUS_TONE = { settled: 'ok', pending: 'warn', noDebts: 'neutral' };

export function saleStatusLabel(settlement) {
	const key = STATUS_LABEL_KEYS[settlement?.status];
	return key ? getLabel(key) : '';
}
